import * as R from 'ramda';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { checkIfCurrentUserAdmin } from '../../utils';
import { getRequestSettings } from '../../redux/selectors';

import OrganizationSettingsModalComp from './organization-settings-modal-comp';

const mapStateToProps = ({ organizationSettings, users }) => ({
  isLoading: organizationSettings.isCreating
    || organizationSettings.isUpdating
    || organizationSettings.isRemoving,
  settings: getRequestSettings({ organizationSettings }),
  editable: checkIfCurrentUserAdmin(R.propOr({}, 'items', users)),
});

export const OrganizationSettingsModal =
  compose(connect(mapStateToProps))(OrganizationSettingsModalComp);



// WEBPACK FOOTER //
// ./src/modals/organization-settings-modal/organization-settings-modal.js